<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationpage" id="d7e142">
<h1 class="chapno">
</h1><h2 class="fmh" id="d7e143"><i>Dedication</i></h2>
<p class="dedicationtext">
<i>For Mom (1947–2009) Thank you Mom for your unconditional love, acceptance, and willingness to talk openly and honestly, even about the hard topics.</i>
</p>
<p class="dedicationtext">
<i>To Jennifer, my best friend, my lover, my partner in crime. Thank you for helping me find the light.</i>
</p>
<p class="dedicationtext">
<i>P.S. I love you.</i>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9781440506963_epub_ded.vue?2029ecbb